export default __webpack_public_path__ + "static/media/digitalSkills.37212d56.png";